import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Tag, Modal,Tabs,Checkbox} from 'antd';
import {PropTypes} from 'prop-types';
import  './styleSectionKnowRelevance.css'
const TabPane = Tabs.TabPane;
class Relevance extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    state = {
        areas:new Map(),
        selectedAreas:[],
    }

    componentDidMount(){

    }
    componentWillReceiveProps(nextProps){
        if(nextProps.visible&&!this.props.visible){
            this.setState({
                areas:new Map(),
                selectedAreas:[],
            })
        }
    }

    onClick=(e,deep,item,area,selected)=>{
    		if(item.list&&item.list.length){//非末级选中
            let arr=this.state[selected];
            arr[deep]=item.city_id;
            arr.splice(deep+1);
            this.setState({[selected]:arr})
        }
        let map = this.state[area]
        if(map.has(item.city_id)){
            map.delete(item.city_id)
        }else{
            map.set(item.city_id,item)
        }
        this.setState({[area]:map})

    }
    list=(list,current,deep,area,selected)=>{
        return (
                <div key={deep} className={'knowlist'}>
                    {
                        list&&list.map((item,key)=>
                            <div key={key}
                                 onClick={(e)=>{this.onClick(e,deep,item,area,selected)}}
                                 className={current===item.city_id?'active':'item'}>
                                 	{	
                                 		item.city_id!='1'&&
                                 		<Checkbox checked={this.state[area].has(item.city_id)}/>
                                 	}
                                    
                                <lable style={{padding:'0 5px'}}>{item.city_name}</lable>
                            </div>
                        )
                    }
                </div>
            )
    }
    loopList=(list,current,deep=0,area,selected)=>{
        if(!list.length){return null}

        if(!this.state[selected][deep]&&list[0].list&& list[0].list.length){
                current = current||list[0].city_id
                this.state[selected][deep]=list[0].city_id
        }

        let arr = []
        arr.push(this.list(list,current,deep,area,selected))//一个选择框

        let next = list.find((val,key)=>{ return val.city_id===current})
        next = next&&next.list
        if(next&&next.length){
            arr.push(
            this.loopList(next,this.state[selected][deep+1],deep+1,area,selected)
            )
        }
        return arr;

    }
    addRelevance=()=>{
        let arr = []
        this.state.areas.forEach((d,key)=>{arr.push(key)})
        this.props.onOk(arr)
    }
    render() {

        return (
            <div>
                <Modal width={1000}
                    title='关联地区'
                    visible={ this.props.visible}
                    onOk={ this.addRelevance }
                    onCancel={ ()=>{this.props.onCancel()} }
                >
                		<div style={{marginBottom:'15px'}}>
                        <span>已选：</span>
                        <span>
                          {
                              [...this.state.areas].map((d,key)=>
                                  <Tag key={key} color="#87d068" style={{margin:'3px'}}>{d[1].city_name}</Tag>
                              )
                          }
                        </span>

                    </div>
                    <div>
                        {this.loopList(this.props.data.areaTree,this.state.selectedAreas[0],0,'areas','selectedAreas')}
                    </div>
                </Modal>

            </div>
        )
    }
}

function mapState(state) {
    return {
        user:state.user
    };
}

function mapDispatch(dispatch) {
    return{

    }
}
export default connect(mapState, mapDispatch)(Relevance);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/addArea.js